import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { Card, Input } from "reactstrap";
import LayoutNoSidebar from "../../Layouts/LayoutNoSidebar";
import {
  getPickupConfirmationDetails,
  clientConfirmPickup,
} from "../../actions/runActions";
import { displayDateFormater, requestHasError } from "../../utils/lib";
import Spinner from "../Common/Spinner";
import { EXPIRED_PICKUP_CONFIRMATION_MESSAGE } from "../../constants";
import { toastr } from "react-redux-toastr";

const getPickupConfirmationMessage = (value) => {
  return (
    <div>
      Your collection of used cooking oil has been scheduled for{" "}
      {displayDateFormater({ value })}. Please ensure that you have moved
      the tank outside or you have 6 or more tins available before confirming
      your collection.
      <div className="mt-1 mb-1">
        If you have any further details or comments please type them in the box
        below
      </div>
    </div>
  );
};

const ClientConfirmPickup = ({
  dispatch,
  siteConfig,
  getPickupConfirmationDetails,
  clientConfirmPickup,
}) => {
  const { token } = useParams();
  const [pageLoading, setPageLoading] = useState(true);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [pickupDetails, setPickupDetails] = useState({ hasExpired: true });
  const [pickupConfirmed, setPickupConfirmed] = useState(false);
  const [pickupStatus, setPickupStatus] = useState("confirmed");
  const [note, setNote] = useState("");

  const handleAccept = () => {
    setAcceptLoading(true);
    const payLoad = {
      confirmOk: true,
      linkId: pickupDetails && pickupDetails.linkId,
      note,
    };
    handleSubmit({ payLoad, type: "Accept" });
  };
  const handleReject = () => {
    setRejectLoading(true);
    const payLoad = {
      confirmOk: false,
      linkId: pickupDetails && pickupDetails.linkId,
      note,
    };
    handleSubmit({ payLoad, type: "Reject" });
  };

  const handleSubmit = ({ payLoad, type }) => {
    dispatch(clientConfirmPickup({ payLoad })).then((x) => {
      setAcceptLoading(false);
      setRejectLoading(false);
      if (!requestHasError({ x })) {
        toastr.success(
          `Pickup ${type === "Accept" ? "Confirmed" : "Declined"}`
        );
        setPickupConfirmed(true);
        setPickupStatus(type === "Accept" ? "confirmed" : "rejected")
      }
    });
  };
  const handleNoteChange = (e) => {
    setNote(e.currentTarget.value);
  };

  useEffect(() => {
    dispatch(
      getPickupConfirmationDetails({ token })
    ).then((x) => {
      setPageLoading(false);
      if (requestHasError({ x })) {
        setPickupDetails({ hasExpired: true });
      } else {
        setPickupDetails({ ...x.data });
      }
    });
  }, []);
  return (
    <LayoutNoSidebar siteConfig={siteConfig}>
      <React.Fragment>
        <h4 style={{ marginBottom: "24px" }}>Confirm Pickup</h4>
        {pageLoading ? (
          <Spinner  />
        ) : (
          <Card
            style={{
              padding: "20px",
              width: "100%",
              maxWidth: "750px",
              borderRadius: "6px",
            }}
          >
            {pickupDetails.hasExpired ? (
              <div>{EXPIRED_PICKUP_CONFIRMATION_MESSAGE}</div>
            ) : 
            pickupConfirmed ?
            <div>Your collection of used cooking oil scheduled for {displayDateFormater({value: pickupDetails.runDate})} has been {pickupStatus}.</div>
            :
            (
              <React.Fragment>
                <div>{getPickupConfirmationMessage(pickupDetails.runDate)}</div>
                <div>
                  <Input
                    type="textarea"
                    rows={5}
                    id="note"
                    value={note}
                    onChange={handleNoteChange}
                  />
                </div>
                <div className="mt-2 mb-1 flex justify-content-between flex-wrap">
                  <button
                    className={`btn btn-primary confirm-pickup-accept-btn ${
                      acceptLoading ? "no-pointer-events" : ""
                    } mobile-screen-button mb-1`}
                    onClick={handleAccept}
                  >
                    <i className="fa fa-check" aria-hidden="true"></i> &nbsp;
                    {acceptLoading
                      ? "Accepting"
                      : "YES - Please come and collect my cooking oil"}
                  </button>
                  <div style={{ flex: "1 1" }}>
                    <button
                      className={`btn btn-danger bold confirm-pickup-reject-btn  ${
                        rejectLoading ? "no-pointer-events" : ""
                      } mobile-screen-button mb-1`}
                      onClick={handleReject}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i> &nbsp;
                      {rejectLoading
                        ? "Rejecting"
                        : "NO - I will not require a collection"}
                    </button>
                  </div>
                  <div className="clearfix" />
                </div>
              </React.Fragment>
            )}
          </Card>
        )}
      </React.Fragment>
    </LayoutNoSidebar>
  );
};
function mapStateToProps(state) {
  return {
    siteConfig: state.apiConfig,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    getPickupConfirmationDetails,
    clientConfirmPickup,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientConfirmPickup);
